export default {
  backLinkNews: 'Tutte le news',
  latestTitle: 'News',
  readNews: 'Leggi l’articolo',
  otherTitle: 'Altri articoli',
}
